<template>
  <div class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link v-for="tag in visitedViews" ref="tag" :class="isActive(tag)?'active':''"
                   :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }" :key="tag.path" tag="span"
                   class="tags-view-item" @click.middle.native="closeSelectedTag(tag)"
                   @contextmenu.prevent.native="openMenu(tag,$event)">
        {{ tag.title }}
        <span class="tag-left"></span>
        <span class="tag-right"></span>
        <span class="el-icon-close" v-if="tag.path !== '/'" @click.prevent.stop="closeSelectedTag(tag)"/>
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">重新加载</li>
      <li @click="closeSelectedTag(selectedTag)">关闭当前</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags">关闭所有</li>
    </ul>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import ScrollPane from '@/components/ScrollPane';

  export default {
    components: {ScrollPane},
    data() {
      return {
        visible: false,
        top: 0,
        left: 0,
        selectedTag: {}
      };
    },
    computed: {
      ...mapGetters({
        visitedViews: 'tags/visitedViews'
      })
    },
    watch: {
      $route() {
        // this.backToTop();
        this.addViewTags();
        this.moveToCurrentTag();
      },
      visible(value) {
        if (value) {
          document.body.addEventListener('click', this.closeMenu);
        }
        else {
          document.body.removeEventListener('click', this.closeMenu);
        }
      }
    },
    mounted() {
      this.addViewTags();
    },
    methods: {
      ...mapActions({
        delCachedView: 'tags/delCachedView',
        delView: 'tags/delView',
        delAllViews: 'tags/delAllViews',
        addView: 'tags/addView',
        addClosedView: 'tags/addClosedView'
      }),
      isActive(route) {
        return route.path === this.$route.path;
      },
      addViewTags() {
        const {name} = this.$route;
        if (name) {
          this.addView(this.$route);
        }
        return false;
      },
      moveToCurrentTag() {
        const tags = this.$refs.tag;
        this.$nextTick(() => {
          for (const tag of tags) {
            if (tag.to.path === this.$route.path) {
              this.$refs.scrollPane.moveToTarget(tag);
              // when query is different then update
              if (tag.to.fullPath !== this.$route.fullPath) {
                this.$store.dispatch('tags/updateVisitedView', this.$route);
              }
              break;
            }
          }
        });
      },
      /**
       * refresh
       */
      refreshSelectedTag(view) {
        this.delCachedView(view).then(() => {
          const {fullPath} = view;
          this.$nextTick(() => {
            this.$router.replace({
              path: '/redirect' + fullPath
            });
          });
        });
      },
      /**
       * close
       */
      closeSelectedTag(view) {
        this.delView(view).then(({visitedViews}) => {
          this.addClosedView(view);
          if (this.isActive(view)) {
            const latestView = visitedViews.slice(-1)[0];
            if (latestView) {
              this.$router.push(latestView);
            }
            else {
              this.$router.push('/');
            }
          }
        });
      },
      /**
       * close
       */
      closeOthersTags() {
        this.$router.push(this.selectedTag);

        this.visitedViews.forEach(v => {
          if (v.name !== this.selectedTag.name) {
            this.addClosedView(v);
          }
        });
        this.$store.dispatch('tags/delOthersViews', this.selectedTag).then(() => {
          this.moveToCurrentTag();
        });
      },
      closeAllTags() {
        this.delAllViews();
        this.visitedViews.forEach(v => {
          this.addClosedView(v);
        });
        this.$router.push('/');
      },
      openMenu(tag, e) {
        const menuMinWidth = 100;
        const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
        const {offsetWidth} = this.$el; // container width
        const maxLeft = offsetWidth + offsetLeft - menuMinWidth; // left boundary
        const left = e.clientX;// - offsetLeft + 15; // 15: margin right

        if (left > maxLeft) {
          this.left = maxLeft;
        }
        else {
          this.left = left;
        }
        this.top = e.clientY;

        this.visible = true;
        this.selectedTag = tag;
      },
      closeMenu() {
        this.visible = false;
      },
      /**
       * layout contain.vue 返回到顶部
       */
      backToTop() {
        document.getElementById('divScroll').scrollTop = 0;
      }
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss">
  .tags-view-container {
    height: 34px;
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);

    .tags-view-wrapper {
      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        height: 26px;
        line-height: 26px;
        border: 1px solid #d8dce5;
        color: #495060;
        background: #fff;
        padding: 0 8px;
        font-size: 12px;
        margin-left: 5px;
        margin-top: 4px;

        &:first-of-type {
          margin-left: 15px;
        }

        &:last-of-type {
          margin-right: 15px;
        }

        &.active {
          background-color: #42b983;
          color: #fff;
          border-color: #42b983;

          &::before {
            content: "";
            background: #fff;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: relative;
            margin-right: 2px;
          }
        }
      }
    }

    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 999999;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;

        &:hover {
          background: #eee;
        }
      }
    }
  }
</style>

<style rel="stylesheet/scss" lang="scss">
  //reset element css of el-icon-close
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transform-origin: 100% 50%;

        &:before {
          transform: scale(0.8);
          display: inline-block;
          vertical-align: -2px;
          font-size: 12px;
        }

        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
</style>
